function rawDataFromNestedArguments(rawData, argList, args) {
  var rd = rawData;
  for (var i = 0; i < argList.length; i++) {
    if (typeof rd !== 'object') {
      throw Error("rawData must contain exactly ".concat(argList.length, " levels for every value"));
    }
    var argKey = argList[i];
    var argValue = args[argKey] || 'default';
    if (rd[argValue] === undefined) {
      if (rd.default === undefined) {
        throw Error('rawData must contain a default element on every level');
      }

      // @ts-expect-error
      rd = rd.default;
    } else {
      // @ts-expect-error
      rd = rd[argValue];
    }
  }

  // @ts-expect-error
  return rd;
}
export function fromConst(create, rawData, tokenOptions) {
  var token = function () {
    return create(rawData);
  };
  token.tokenOptions = tokenOptions;
  return token;
}
export function fromNestedArguments(create, rawData, argList, tokenOptions) {
  // @ts-expect-error
  var fromNested =
  // @ts-expect-error
  rawDataFromNestedArguments.bind(null, rawData, argList);
  var token = function (args, fromRef) {
    var raw = fromNested(args);
    if (typeof raw === 'function') {
      var refLookup = raw;
      return refLookup(fromRef, args);
    }
    return create(raw);
  };
  token.tokenOptions = tokenOptions;
  return token;
}
//# sourceMappingURL=base.js.map